module.exports = __webpack_public_path__ + "static/media/logo-header.70689983.png";